<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.90002 7.56023C9.21002 3.96023 11.06 2.49023 15.11 2.49023H15.24C19.71 2.49023 21.5 4.28023 21.5 8.75023V15.2702C21.5 19.7402 19.71 21.5302 15.24 21.5302H15.11C11.09 21.5302 9.24002 20.0802 8.91002 16.5402"
            stroke="#00094F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <g opacity="0.4">
            <path
                d="M14.9991 12H3.61914"
                stroke="#00094F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M5.85 8.65039L2.5 12.0004L5.85 15.3504"
                stroke="#00094F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
    </svg>
</template>
